import Vue from 'vue'
import Router from 'vue-router'
import store from 'src/store'
import config from 'src/config'
import helpers from 'src/helpers'

const requireComponent = require.context(
  // Look for files in the current directory
  '../application',
  // Look in  subdirectories
  true,
  // Only include "_base-" prefixed .vue files
  /router.js$/
)

let routes = []
// For each matching file name...
requireComponent.keys().forEach(fileName => {
  // Can use _ to turn route off
  if (fileName.indexOf('_') === -1) {
    routes = [...routes, ...requireComponent(fileName).default]
  }
})

/**
 *  Update route `meta.title` attribute if this attribute using `@` format
 *  which holds partial translation key from translation mapping json
 *  if meta.title contain `@translation.key` with `@` identifier will be replaced
 *  with full translation `key`.
 *  please refer `src/helpers/translator.js` for full info
 * @returns {function(*): Promise<void>}
 */
let updateRoutesTranslations = () => async obj => {
  if (obj.meta && obj.meta.title) {
    obj.meta.title = obj.meta.title.includes('@')
      ? await helpers.preTranslator(obj.meta.title.replace('@', ''))
      : obj.meta.title
    if (obj.children && obj.children.length > 0) {
      obj.children.forEach(updateRoutesTranslations())
    }
  }
}

/**
 *  Dont move this section
 *  Responsible for translation key replacement
 */
routes.forEach(updateRoutesTranslations())

Vue.use(Router)

const createRouter = (data = routes) =>
  new Router({
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
    linkActiveClass: 'open active in-view',
    routes: data,
  })

export let router = createRouter()

export let newRouter = {}

export async function resetRouter(data) {
  /** Merge guarded routes with original routes to get back functions **/
  data = _.merge(data, routes)
  newRouter = await createRouter(data)
  router.matcher = newRouter.matcher
}

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  // Clear pending API calls
  Vue.prototype.$http.clear()
  // Clear form errors of previous route before move next route
  let toQuery = helpers.getValue(to, 'query', {})

  let { skipErrorFlush = false } = toQuery

  if (!skipErrorFlush) {
    store.dispatch('resetErrorsAction')
  }
  store.dispatch('resetOpenCloseModalAction')
  // Commented for purpose do not remove
  // if (!hasQueryParams(to) && hasQueryParams(from)) {
  //   next({ name: to.name, query: from.query })
  // } else {
  //   next()
  // }
  next()
})

router.afterEach((to, from) => {
  let body = document.querySelector('body')
  body.className = Vue.prototype.$customStore.getters.isLoggedIn ? 'dashboard-area' : 'auth-area'
  body.id = config.app.scope === 'evo' ? (config.app.isOnePlan ? 'one-plan' : 'evo') : 'ibs'
})

export default router
